import { Container, Grid, Box } from '@mui/material';
import { dateFormats, sensorProfileIds } from 'dips-models';
import { useTheme } from '@mui/styles';
import dayjs from 'dayjs';
import React, { useState, useEffect } from 'react';

import { api as apiDefs } from '../config/authConfig';
import { getList } from '../Components/crud-helper';
import { useDataFilter } from '../contexts/dataFiltersContext';
import { UserContext } from '../contexts/userContext';
import Filters from '../Components/Filters';
import FormBase from './form-base';
import models from '../config/models';
import ReportLogo from '../assets/logo.png'
import util from '../util';
const { reportDurationDateFormat, reportCreatedDateFormat } = dateFormats;
const dateFormat = 'YYYY-MM-DD';
const profileIdForDoorSensor = sensorProfileIds.door;
const doorModel = models.filter((ele) => ele.name === 'doorMovementHistory')[0];
const doorModelDashboard = { ...doorModel };
const baseLookupParams = [
	{ lookupType: 'hospital' },
	{ lookupType: 'room' },
	{
		lookupType: 'sensor',
		include: [{ model: 'sensorType', as: 'sensorType' }],
		where: { '$sensorType.profileId$': profileIdForDoorSensor }
	}
];

function DoorMovementReport() {
	const [userContext] = React.useContext(UserContext);
	const [chartData, setChartData] = useState({ data: [], hospitals: '' });
	const [hospitalsFilterData, setHospitalsFilterData] = useState([]);
	const [roomsFilterData, setRoomsFilterData] = useState([]);
	const [sensorFilterData, setSensorFilterData] = useState([]);
	const [label, setLabel] = useState({ roomLabel: '', sensorLabel: '', hospitalLabel: '' });
	const { palette } = useTheme();
	const [parentFilters, setParentFilters] = useDataFilter({
		ProfileId: profileIdForDoorSensor,
		Date: {
			operator: 'between',
			startDate: dayjs().subtract(6, 'day').format(dateFormat),
			endDate: dayjs().format(dateFormat)
		}
	});
	const extraParams = {
		report: 'DoorMovementHistory',
		indexName: `telemetry-${new Date().toISOString().substring(0, 7)}-door`,
		valueField: 'duration'
	};
	const printHospitalVal=util.printHospital(hospitalsFilterData,parentFilters);
	useEffect(() => {
		let parentF = { ...parentFilters };
		getList({
			page: 0,
			pageSize: 10,
			sortModel: [],
			gridColumns: [],
			api: `${apiDefs.base}/telemetry/summary`,
			setIsLoading: () => {},
			setData: (data) => {
				if (data.rows && data.rows.length > 0) {
					data.rows.sort(function (a, b) {
						return new Date(a.Date) - new Date(b.Date);
					});
					let barChartData = data.rows.map((item) => {
						return { date: dayjs(item.Date).format(dateFormat), Duration: item.range, Count: item.count };
					});
					setChartData({ ...chartData, data: barChartData, hospitals: data.hospitals.join(',') });
				} else {
					setChartData({ ...chartData, data: [], hospitals: '' });
				}
			},
			modelConfig: { formDef: [] },
			parentFilters: {
				...parentF
			},
			action: 'report',
			extraParams: extraParams
		});
	}, [parentFilters]);

	return (
		<Container
			maxWidth="lg"
			sx={{
				mt: 5,
				mb: 4,
				backgroundColor: palette.primary.light_1,
				padding: '26px 20px 10px 0px'
			}}
		>
			<Filters
				setParentFilters={setParentFilters}
				parentFilters={parentFilters}
				setLabel={setLabel}
				label={label}
				showSensorTypeFilter={false}
				lookupParams={baseLookupParams}
				hospitalsFilterData={hospitalsFilterData} 
				setHospitalsFilterData={setHospitalsFilterData}
				roomsFilterData={roomsFilterData}
				setRoomsFilterData={setRoomsFilterData}
				sensorFilterData={sensorFilterData}
				setSensorFilterData={setSensorFilterData}
			/>
			<Grid row>
				<Grid spacing={3} sx={{ mt: 3 }}>
					<Box className="only-print-content print-pd0" sx={{ p: 1 }}>
						<Box display="flex" justifyContent="center" alignItems="center" mb={1}>
							<img src={ReportLogo} style={{ width: 200, height: 40 }} alt={`${userContext?.docTitle}`} />
						</Box>
						<Box
							sx={{ fontWeight: 'bold', textDecoration: 'underline' }}
							mb={5}
							pt={2}
							display="flex"
							justifyContent="center"
							alignItems="center"
						>
							Door History Regulatory Report
						</Box>
						<Box className="report-header-container">
							<Box>Hospital: {printHospitalVal}</Box>
							<Box>
								Dates: {dayjs(parentFilters.Date.startDate).format(reportDurationDateFormat)} to{' '}
								{dayjs(parentFilters.Date.endDate).format(reportDurationDateFormat)}
							</Box>
							<Box>Created: {dayjs().format(reportCreatedDateFormat)}</Box>
						</Box>
					</Box>
				</Grid>
			</Grid>
			<Grid row>
				<Grid spacing={3} sx={{ mt: 7 }}>
					<FormBase
						title={`${doorModel.title} - ${printHospitalVal?printHospitalVal:'All'}`}
						modelConfig={doorModelDashboard}
						key={doorModelDashboard.title}
						parentFilters={parentFilters}
						action={'report'}
						extraParams={extraParams}
					/>
				</Grid>
			</Grid>
		</Container>
	);
}

export default DoorMovementReport;
